export default __webpack_public_path__ + "static/UTA_MEDIALINK-6cd1f42a071b7003ebcffbb94f3fdf19.png";